export default __webpack_public_path__ + "static/media/s1.6f620392.jpg";